import { success } from "toastr";
import {
  FETCH_DEDUCTIONS,
  FETCH_DEDUCTIONS_SUCCESS,
  FETCH_DEDUCTIONS_FAILURE,
  CREATE_DEDUCTION_REQUEST,
  CREATE_DEDUCTION_SUCCESS,
  CREATE_DEDUCTION_FAILURE,
  DELETE_DEDUCTION,
  DELETE_DEDUCTION_SUCCESS,
  DELETE_DEDUCTION_FAILURE,  
  CHANGE_DEDUCTION_STATUS,
  CHANGE_DEDUCTION_STATUS_SUCCESS,
  CHANGE_DEDUCTION_STATUS_FAILURE
} from "./actionTypes";

const initialState = {
  deductions: [],
  loading: false,
  error: null,
  success:false
};

const payrollSetupDeductionReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_DEDUCTIONS:
      return { ...state, loading: true };
    case FETCH_DEDUCTIONS_SUCCESS:
      return { ...state, loading: false, deductions: action.payload.data};
    case FETCH_DEDUCTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_DEDUCTION_STATUS:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_DEDUCTION_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_DEDUCTION_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CREATE_DEDUCTION_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_DEDUCTION_SUCCESS:
      return { ...state, loading: false, success:true, deductionData: action.payload, error: null };

    case CREATE_DEDUCTION_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_DEDUCTION:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_DEDUCTION_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_DEDUCTION_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
      

    default:
      return state;
  }
};

export default payrollSetupDeductionReducer;
